module.exports = __webpack_public_path__ + "img/stone-ditch.295fc918.jpg";